export default __webpack_public_path__ + "static/media/SemiBold.5a87f7c4.woff";